import React from 'react'
// components
import KPIContainer from 'containers/KPIs/Register'

const KPIPage: React.FC = () => <KPIContainer />

export default KPIPage
